import {createStore} from 'vuex'
import moment from "moment";
import {getDefaultProductId, getProductIdForBrand} from "@/config";

export default createStore({
    state: {
        msisdn: undefined,
        serviceId: undefined,
        brandConfig: undefined,
        upcomingFixtures: [],
        showAutoTeamBuilder: false,
        showHowToWinPoints: false,
        isLoading: undefined,
        roundId: undefined,
        leagueName: undefined,
        showSelectCaptain: false,
        showHint: false,
        showTriviaGameOver: false,
        showEditUserName: false,
        showEditAvatar: false,
        showInviteFriend: false,
        showSingleMatch: false,
        roundsEntered: 0,
        liveRoundsNotEntered: 0,
        productId: 26,
        user: undefined,
        showNoQuestions: false,
        showUnsubPopup: false,
        defferedPrompt: null,
        showAddToHomeScreen: false,
        showUpgradeToPremium: false,
        feedArticles: [],
        campaignId: 0,
        predictorUserStats : undefined,
        clickedTournamentId: undefined,
        completedRounds: [],
        tournamentRoundTimers: {},
        showTournamentModal: false,
        showVoucherEarnedPopup: false
    },
    mutations: {
        setShowVoucherEarnedPopup(state, showVoucherEarnedPopup) {
            state.showVoucherEarnedPopup = showVoucherEarnedPopup
        },
        addCompletedRound(state, { tournamentId, bracketId }) {
            state.completedRounds.push({
                tournamentId,
                bracketId,
                shownAt: moment().toISOString()
            });
        },
        setTournamentRoundTimer(state, { key, timerId }) {
            state.tournamentRoundTimers[key] = timerId;
        },
        clearTournamentRoundTimer(state, key) {
            if (state.tournamentRoundTimers[key]) {
                clearTimeout(state.tournamentRoundTimers[key]);
                delete state.tournamentRoundTimers[key];
            }
        },
        clearAllTournamentTimers(state) {
            Object.values(state.tournamentRoundTimers).forEach(timerId => {
                clearTimeout(timerId);
            });
            state.tournamentRoundTimers = {};
        },
        setClickedTournamentId (state, clickedTournamentId) {
            state.clickedTournamentId = clickedTournamentId
        },
        setShowTournamentModal(state, showTournamentModal) {
            state.showTournamentModal = showTournamentModal
        },
        setFeedArticles(state, feedArticles) {
            state.feedArticles = feedArticles
        },
        setShowUpgradeToPremium(state, showUpgradeToPremium) {
            state.showUpgradeToPremium = showUpgradeToPremium
        },
        setShowAddToHomeScreen(state, showAddToHomeScreen) {
            state.showAddToHomeScreen = showAddToHomeScreen
        },
        setDeferredPrompt(state, defferedPrompt) {
            state.defferedPrompt = defferedPrompt
        },
        setShowUnsubPopup(state, showUnsubPopup) {
            state.showUnsubPopup = showUnsubPopup
        },
        setShowNoQuestions (state, showNoQuestions) {
            state.showNoQuestions = showNoQuestions
        },
        setLiveRoundsNotEntered(state, liveRoundsNotEntered) {
            state.liveRoundsNotEntered = liveRoundsNotEntered
        },
        setRoundsEntered(state, roundsEntered) {
            state.roundsEntered = roundsEntered
        },
        setShowSingleMatch(state, showSingleMatch) {
            state.showSingleMatch = showSingleMatch
        },
        setServiceId(state, serviceId) {
            state.serviceId = serviceId
            if (!state.brandConfig?.brand) return;
            const resolvedProductId = getProductIdForBrand(state.brandConfig.brand, serviceId)
                ?? state.brandConfig.productId
                ?? state.productId;
            state.productId = resolvedProductId;
            state.brandConfig.productId = resolvedProductId;
        },
        setMsisdn(state, msisdn) {
            state.msisdn = msisdn
        },
        setShowInviteFriend(state, showInviteFriend) {
            state.showInviteFriend = showInviteFriend
        },
        setShowEditAvatar(state, showEditAvatar) {
            state.showEditAvatar = showEditAvatar
        },
        setShowEditUserName(state, showEditUserName) {
            state.showEditUserName = showEditUserName
        },
        setShowTriviaGameOver(state, showTriviaGameOver) {
            state.showTriviaGameOver = showTriviaGameOver
        },
        setShowHint(state, showHint) {
            state.showHint = showHint
        },
        setShowSelectCaptain(state, showSelectCaptain) {
            state.showSelectCaptain = showSelectCaptain
        },
        setShowHowToWinPoints(state, showHowToWinPoints) {
            state.showHowToWinPoints = showHowToWinPoints
        },
        setShowAutoTeamBuilder(state, showAutoTeamBuilder) {
            state.showAutoTeamBuilder = showAutoTeamBuilder
        },
        setUpcomingFixtures(state, upcomingFixtures) {
            state.upcomingFixtures = upcomingFixtures
        },
        setBrandConfig(state, brandConfig) {
            const resolvedProductId = getProductIdForBrand(brandConfig.brand, state.serviceId)
                ?? getDefaultProductId(brandConfig.brand)
                ?? brandConfig.productId;
            state.brandConfig = {
                ...brandConfig,
                productId: resolvedProductId,
                defaultProductId: brandConfig.defaultProductId ?? resolvedProductId,
            }
            state.productId = resolvedProductId
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading
        },
        setUser(state, user) {
            state.user = user
        },
        setRoundId(state, roundId) {
            state.roundId = roundId
        },
        setLeagueName(state, leagueName) {
            state.leagueName = leagueName
        },
        setCampaignId(state, campaignId) {
            state.campaignId = campaignId
        },
        setProductId(state, productId) {
            state.productId = productId
            if (state.brandConfig) state.brandConfig.productId = productId
        },
        setPredictorUserStats(state, predictorUserStats) {
            state.predictorUserStats = predictorUserStats
        },
    },
})
